<template>
  <!DOCTYPE html>
  <html>
  <head>

  </head>
  <body>
    <md-layout :md-gutter="40">
      <md-layout>
      </md-layout>

      <md-layout>
        <h1>Authorization in progress...</h1>
        <md-spinner md-indeterminate id="networkSpinner"></md-spinner>
      </md-layout>

      <md-layout>
      </md-layout>
    </md-layout>

  </body>
  </html>

</template>

<script>
  import dfpService from '../../services/dfpService';
  export default {
    name: 'GoogleCallbackPage',
    components: {
      //Sidebar,
      //Toolbar,
    },
    computed: {
      pageName() {
        return "Google callback page";
      },
    },
    methods: {
      getParameterByName(name) {
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
        var results = regex.exec(window.location.search);
        if (results && results[2]) {
          return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
        return null;
      }
    },
    mounted() {
      var authCode = this.getParameterByName('code');
      var authSuccess = !this.getParameterByName('err');

      if (authCode) {
        const redirBaseUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '') + "/google/OAuthCallback";
        dfpService.oauthCallback(authCode, redirBaseUrl)
          .then(data => {
            window.opener.localStorage.setItem('googleOAuthSuccess', 1);
            window.close();
          })
          .catch(error => {
            console.error(`Error while calling oauthCallback`, error);
            window.opener.localStorage.setItem('googleOAuthSuccess', 0);
            window.close();
          });
      }
    }
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/spa/google/GoogleCallback.vue